import React from 'react';
import { Row, Col, Image } from 'antd';
import sanitizeHtml from 'sanitize-html';
import parse, { HTMLReactParserOptions, Element, DOMNode } from 'html-react-parser';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import * as gtag from 'lib/gtag';
import ImageContainer from './ImageContainer';
import ImageCaption from './ImageCaption';

const VideoPlayer = dynamic(() => import('components/VideoPlayer'), {
    ssr: false
});
interface Props {
    children: string | React.JSX.Element;
}

function domNodeIsElement(domNode: DOMNode): domNode is Element {
    return domNode.type === 'tag';
}

const parseContent = (content: string | React.JSX.Element, currentPath: string) => {
    const options: HTMLReactParserOptions = {
        replace: (domNode) => {
            if (domNodeIsElement(domNode) && domNode.attribs.class === 'article-video') {
                return (
                    <Row>
                        <Col span={24}>
                            <VideoPlayer
                                light={domNode.attribs['aria-placeholder']}
                                url={domNode.attribs['aria-valuetext']}
                                onStart={() => {
                                    gtag.event({
                                        action: 'Play',
                                        category: 'Videos',
                                        label: domNode.attribs['aria-placeholder'],
                                        value: currentPath
                                    });
                                }}
                            />
                        </Col>
                    </Row>
                );
            }
            if (domNodeIsElement(domNode) && domNode.name === 'img') {
                const caption = domNode.attribs['aria-labelledby'];
                return (
                    <ImageContainer>
                        <Image src={domNode.attribs.src} width="100%" />
                        {caption && (
                            <ImageCaption
                                dangerouslySetInnerHTML={{ __html: sanitizeHtml(caption) }}
                            />
                        )}
                    </ImageContainer>
                );
            }
        }
    };
    return parse(content as string, options);
};

const HtmlDescription = ({ children }: Props) => {
    const router = useRouter();
    return <>{parseContent(children, router.asPath)}</>;
};

export default HtmlDescription;
